// extracted by mini-css-extract-plugin
export var grayBottomBorder = "header-module--gray-bottom-border--Ht0+F";
export var navLink = "header-module--nav-link--SkCii";